import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { isMobile } from '../utils/device'
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_KEYWORDS,
  applyRouteSeo,
  getOrganizationJsonLd,
  getWebSiteJsonLd,
} from '../utils/seo'

// PC 端组件
const HomePC = () => import('../views/Home.vue')
const ProductsPC = () => import('../views/Products.vue')
const ProductDetailPC = () => import('../views/ProductDetail.vue')
const NewsPC = () => import('../views/News.vue')
const NewsDetailPC = () => import('../views/NewsDetail.vue')
const MerchantDetailPC = () => import('../views/MerchantDetail.vue')
const LoginPC = () => import('../views/Login.vue')

// H5 端组件位于 src/views/h5/
const HomeH5 = () => import('../views/h5/Home.vue')
const ProductsH5 = () => import('../views/h5/Products.vue')
const ProductCategoriesH5 = () => import('../views/h5/ProductCategories.vue')
const ProductDetailH5 = () => import('../views/h5/ProductDetail.vue')
const NewsH5 = () => import('../views/h5/News.vue')
const NewsDetailH5 = () => import('../views/h5/NewsDetail.vue')
const MerchantDetailH5 = () => import('../views/h5/MerchantDetail.vue')
const LoginH5 = () => import('../views/h5/Login.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => (isMobile() ? HomeH5() : HomePC()),
    meta: {
      seo: {
        title: 'Jinjiang Shoe Textile City',
        description: DEFAULT_DESCRIPTION,
        keywords: DEFAULT_KEYWORDS,
        path: '/',
        structuredData: [getOrganizationJsonLd(), getWebSiteJsonLd()],
      },
    },
  },
  {
    path: '/products',
    name: 'Products',
    component: () => (isMobile() ? ProductsH5() : ProductsPC()),
    meta: {
      seo: {
        title: 'Products',
        description:
          'Explore footwear, textile and sourcing products from Jinjiang Shoe Textile City suppliers.',
        keywords:
          'Jinjiang products, footwear products, textile products, sourcing products, shoe suppliers',
        path: '/products',
      },
    },
  },
  {
    path: '/products/categories',
    name: 'ProductCategories',
    component: () => (isMobile() ? ProductCategoriesH5() : ProductsPC()),
    meta: {
      seo: {
        title: 'Product Categories',
        description:
          'Browse shoe and textile product categories from Jinjiang Shoe Textile City.',
        keywords:
          'shoe categories, textile categories, footwear sourcing, Jinjiang product categories',
        path: '/products/categories',
      },
    },
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => (isMobile() ? ProductDetailH5() : ProductDetailPC()),
    meta: {
      seo: {
        title: 'Product Detail',
        description:
          'View product details, specifications and supplier information from Jinjiang Shoe Textile City.',
        keywords:
          'product detail, footwear supplier, textile supplier, Jinjiang sourcing',
      },
    },
  },
  {
    path: '/news',
    name: 'News',
    component: () => (isMobile() ? NewsH5() : NewsPC()),
    meta: {
      seo: {
        title: 'News',
        description:
          'Read the latest news, updates and trade information from Jinjiang Shoe Textile City.',
        keywords:
          'Jinjiang news, shoe textile news, trade news, sourcing updates',
        path: '/news',
      },
    },
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => (isMobile() ? NewsDetailH5() : NewsDetailPC()),
    meta: {
      seo: {
        title: 'News Detail',
        description:
          'Read news and updates from Jinjiang Shoe Textile City.',
        keywords:
          'Jinjiang news detail, footwear textile news, international trade news',
        type: 'article',
      },
    },
  },
  {
    path: '/merchants/:id',
    name: 'MerchantDetail',
    component: () => (isMobile() ? MerchantDetailH5() : MerchantDetailPC()),
    meta: {
      seo: {
        title: 'Merchant Detail',
        description:
          'Discover merchant profiles, contact information and recommended products at Jinjiang Shoe Textile City.',
        keywords:
          'Jinjiang merchant, supplier profile, footwear supplier, textile supplier',
      },
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => (isMobile() ? LoginH5() : LoginPC()),
    meta: {
      seo: {
        title: 'Login',
        description: 'Login to Jinjiang Shoe Textile City.',
        keywords: DEFAULT_KEYWORDS,
        path: '/login',
        robots: 'noindex,nofollow',
      },
    },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, left: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated
  const isAdmin = store.getters.isAdmin

  if (to.meta.guest && isAuthenticated) {
    next('/')
    return
  }

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }

  if (to.meta.requiresAdmin && !isAdmin) {
    next('/')
    return
  }

  next()
})

router.afterEach((to) => {
  applyRouteSeo(to)
})

export default router
